
import { Options, prop, Vue } from 'vue-class-component';

class Props {
  dataLength = prop<number>({
    default: 0,
    type: Number
  });
  limit = prop<number>({
    default: 10,
    type: Number
  });
}

@Options({
  emits: ['update:limit'],
})
export default class ButtonLoadMore extends Vue.with(Props) {
  onClick() {
    if (this.dataLength > this.limit) {
      this.$emit('update:limit', this.limit + 10);
    };
  }
};
